import { createAppSelector } from '../root/utils';
import type { RootState } from '../root/types';

export const makePropertySelector =
  <TFeature extends keyof RootState>(feature: TFeature) =>
  <TProperty extends keyof RootState[TFeature]>(property: TProperty) =>
    createAppSelector((state) => state[feature][property]);
